<template>
  <div>
    <div ref="editor"
         :readonly="_readonly"
         class="form-control" style="height: 300px"></div>
    <div>
      <button v-if="!_readonly" class="btn btn-sm" type="button" @click="reformat">
        {{i18n.fr('action.reformat_code')}}
      </button>
    </div>
    <div v-if="err" class="text-danger"><i class="ti ti-alert"></i>{{err.message}}</div>
  </div>
</template>

<script>
  import mixin from './mixin';

  export default {
    name: 'f-json',
    mixins: [mixin],
    data() {
      return {
        editor: null,
        err: null,
        json: '',
        _json: '',
      };
    },
    watch: {
      json() {
        try {
          let o = JSON.parse(this.json);
          let _json = JSON.stringify(o);
          if (this._json != _json) {
            this._json = _json;
            this.value = o;
          }
          this.err = null;
        } catch (e) {
          this.err = e;
        }
      },
      value() {
        let _json = JSON.stringify(this.value);
        if (this._json != _json) {
          this._json = _json;
          this.editor.setValue(JSON.stringify(this.value, null, '\t'));
        }
        this.err = null;
      },
      _readonly() {
        this.editor.setReadOnly(this._readonly);
      },
    },
    methods: {
      validate() {
        return Promise.resolve(!this.err);
      },
      reformat() {
        try {
          this._json = '';
          this.value = Function('return (' + this.json + ')')();
        } catch (e) {
          this.err = e;
        }
      },
    },
    mounted() {
      this.editor = window.ace.edit(this.$refs.editor);
      this.editor.setReadOnly(this._readonly);
      this.editor.getSession().setMode("ace/mode/json");
      this._json = JSON.stringify(this.value);
      this.json = JSON.stringify(this.value, null, '\t') || '';
      this.editor.setValue(this.json);
      this.editor.clearSelection();
      this.editor.getSession().on('change', () => {
        this.json = this.editor.getValue();
      });
    },
  };
</script>



// WEBPACK FOOTER //
// f-json.vue?61ab60e0